import { getDeepProperty } from '@/helpers/deepObject.js'

const getters = {
  accounts: state => getDeepProperty(state, 'user.accounts.collection'),
  accountsUserHasCreatePerms: state => (getters.accounts(state) || []).filter((a) => a.permission && a.permission.can_create_podcast),
  accountApiKey: state => state.accountApiKey.api_key,
  authorizedApps: (state) => {
    return getDeepProperty(state, 'user.authorized_apps.collection') || {}
  },
  currentAccount: state => {
    // Need to jump through a few extra hoops so we can use the refreshAccount function
    if (!state.user || !state.user.accounts || !state.user.accounts.collection || !state.currentAccount) return state.currentAccount

    let account = state.user.accounts.collection.find(account => account.id === state.currentAccount.id)

    return account || state.currentAccount
  },
  defaultAccount: (state) => {
    // THIS IS TEMPORARY, BECAUSE WE NEED TO MOVE THE fetchUser FUNCTION OUT OF LAYOUT
    // SO IT'S BLOCKING AND NOTHING ELSE TRIES TO LOAD BEFORE THEN
    if (!state.user || !state.user.accounts || !state.user.accounts.collection) return {}

    let defaultAccount = state.user.accounts.collection.find(account => account.is_default)

    return defaultAccount || {}
  },
  currentAccountNav: state => state.currentAccountNav,
  currentAccountId: state => (getters.currentAccount(state) || {}).id,
  defaultAccountId: state => getters.defaultAccount(state).id,
  currentAccountPermission: state => (getters.currentAccount(state) || {}).permission || {},
  featureFlags: state => state.featureFlags,
  notification: state => state.notification,
  orgPodcasts: state => state.orgPodcasts,
  orgPodcastsCount: state => state.orgPodcastsCount,
  orgPodcastsTotal: state => state.orgPodcastsTotal,
  privateApps: (state) => {
    if (!state.user || !state.user.accounts || !state.user.accounts.collection) return {}

    let defaultAccount = state.user.accounts.collection.find(account => account.is_default)

    return getDeepProperty(defaultAccount, 'private_apps.collection') || {}
  },
  twoFactor: state => state.twoFactor,
  updateError: state => state.updateError,
  user: state => state.user,
  userHasOrgsUi: state => {
    let accounts = getters.accounts(state)
    if (!accounts || !accounts.length) return false
    const orgsWithUi = accounts.filter((o) => o.features && o.features.has_networks_ui)
    return orgsWithUi && orgsWithUi.length > 0
  },
  userInvites: state => state.userInvites
}

export default getters
